import { Injectable } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { map, switchMap, catchError } from 'rxjs/operators'
import {
  loadHomepagesUserGraphsSuccess,
  loadHomepagesUserGraphsFailure,
} from '../actions/homepages-user-graph.actions'
import { HomepagesUserGraphService } from '../services/homepages-user-graph.service'
import * as CriteriaActions from '../actions/criteria.actions'
import { of } from 'rxjs'

@Injectable()
export class HomepagesUserGraphEffects {
  constructor(private actions$: Actions, private service: HomepagesUserGraphService) {}

  loadHomepagesUserGraph = createEffect(() =>
    this.actions$.pipe(
      ofType(CriteriaActions.refreshData),
      switchMap(action =>
        this.service.findHomepagesUserGraph(action.artistId, action.from, action.to).pipe(
          map(d => loadHomepagesUserGraphsSuccess({ homepagesUser: d })),
          catchError(error => of(loadHomepagesUserGraphsFailure({ error })))
        )
      )
    )
  )
}
